/**
 * Remove margin-bottom from an alignfull block if there's another alignfull block after it
 */

let all_blocks = document.querySelectorAll(".blocks > *");
if (all_blocks.length > 0) {
  all_blocks = Array.from(all_blocks);
  document.querySelectorAll(".blocks > *").forEach((el) => {
    if (el.classList.contains("alignfull")) {
      if (el.nextElementSibling) {
        if (el.nextElementSibling.classList.contains("alignfull")) {
          el.classList.add("mb-0");
        }
      }
    }
  });
}
